import React from 'react';
import c from 'classnames';

import type { Langcodes } from '@uncinc/react-drupal-core/types';

import MetaSearch, { type MetaSearchProps } from '../Search/MetaSearch';
import { constructQuery } from '../Search/MetaSearch/metaParagraphsHelpers';

import './style.scss';

export interface RelatedContentProps extends Pick<MetaSearchProps, 'contentType' | 'hitsPerPage'> {
  title?: string;
  filterName: string;
  filterValue: string | number;
  langcode: Langcodes,
  className?: string;
}

const RelatedContentInner: React.FC<Pick<RelatedContentProps, 'title' | 'contentType' | 'className'>> = (props) => {
  const {
    title,
    contentType,
    className,
  } = props;

  const classes = c('RelatedContent', `RelatedContent--${contentType}`, className);

  return (
    <div className={classes}>
      {title && (
        <h2 className="RelatedContent__title">
          {title}
        </h2>
      )}

      <MetaSearch.Inner />
    </div>
  );
};

const RelatedContent: React.FC<RelatedContentProps> = (props) => {
  const {
    title,
    contentType,
    hitsPerPage,
    filterName,
    filterValue,
    className,
    langcode,
  } = props;

  return (
    <MetaSearch
      contentType={contentType}
      hitsPerPage={hitsPerPage}
      requestOptions={{
        getBaseFilters: () => [
          constructQuery(contentType, langcode),
          {
            bool: {
              must: [
                {
                  term: {
                    [filterName]: {
                      value: filterValue,
                    },
                  },
                },
              ],
            },
          },
        ],
      }}
    >
      <RelatedContentInner
        title={title}
        contentType={contentType}
        className={className}
      />
    </MetaSearch>
  );
};

export default RelatedContent;
